import type { FontConfig } from "@/domains/design/types"
import type { DeepPartial } from "@/domains/library"
import type { ResponsiveMode } from "@/hooks/use-responsive"
import { useFontConfig } from "@/domains/design/hooks/use-font-config"
import { BODY_XS_CONFIG } from "@/domains/design/system/body-xs"
import { cn } from "@/domains/library"

export const BodyXs = ({
  children,
  className,
  options,
  mode,
  As = "p",
}: {
  children?: React.ReactNode
  className?: string
  options?: DeepPartial<FontConfig>
  mode?: ResponsiveMode
  As?: React.ElementType
}) => {
  const config = useFontConfig({ baseConfig: BODY_XS_CONFIG, options, mode })

  if (!config) {
    return null
  }

  return (
    <As
      className={cn(config.family.tw, config.weight.tw, config.size.tw, config.lineHeight.tw, "text-t100", className)}
    >
      {children}
    </As>
  )
}
